import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button } from '@myphx-engineering/phx-design-system';

import { getAbsoluteRoute } from '../../../util';

export const PriorAuthPickPharmacyButton = ({
    prescriptionId,
    sentToPharmacy,
}: {
    prescriptionId?: string;
    sentToPharmacy: boolean;
}) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const buttonText = sentToPharmacy
        ? t('priorAuthorization.statusPage.button.alreadySent')
        : t('priorAuthorization.statusPage.button.pickAPharmacy');

    if (!prescriptionId) {
        return null;
    }

    return (
        <Button
            disabled={!!sentToPharmacy}
            onClick={() =>
                navigate(
                    getAbsoluteRoute('cabinet.rxId.root', {
                        prescriptionId,
                    })
                )
            }
        >
            {buttonText}
        </Button>
    );
};
